import { render } from "./CreatePool.vue?vue&type=template&id=72b91152&scoped=true"
import script from "./CreatePool.vue?vue&type=script&lang=js"
export * from "./CreatePool.vue?vue&type=script&lang=js"

import "@/Common/Styles/createPool.scss?vue&type=style&index=0&id=72b91152&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b91152"]])

export default __exports__